import { 
  Form, 
  Input, 
  Button, 
  Select,
  Result,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { signularisApi, useCreateMetaDocumentMutation, useGetRecipientsListQuery } from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import genDocument2 from '../misc/gendoc2';
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import style from '../CreateDocument.module.scss';
import { SendOutlined } from "@ant-design/icons";

const { Item } = Form;
const { Option } = Select;

// Генерирует ID
let guid = () => {
  let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
  return s4() + s4() + s4() + s4();
}

// Дата для документа
function styledDate() {
  const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", 
                  "августа", "сентября", "октября", "ноября", "декабря"]
  const dobj = new Date()
  return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
  const info = useSelector((state: RootState) => state.userinfo)
  const dispatch = useAppDispatch()
  const { data: recipientsList } = useGetRecipientsListQuery()
  const [docname, setDocname] = useState("")
  const docTemplate : DocTemplateType = 'paidLeave'

  const [createMetaDocument, {
    isLoading: mutationLoading, 
    isSuccess: mutationSuccess, 
    isError: mutationError,
  } ] = useCreateMetaDocumentMutation()

  const [form] = useForm()

  const onFinish = async (values: any) => {
    const regnum = guid()
    setDocname('Заявление на оплачиваемый отпуск')
    const formData = new FormData()
    formData.append("title", `Заявление на оплачиваемый отпуск №${regnum}`)
    formData.append("brief", "Сгенерировано из шаблона")
    formData.append("recipients", values.recipients.join(","))
    formData.append("documentType", docTemplate)

    const templateValues = {
        ...values,
        regnum,
        regdate: styledDate(),
        dutyface: `${info.lastname} ${info.firstname} ${info.middlename}`
    }
    
    const pdfBytes = await genDocument2(templateValues, info)
    formData.append("file", new Blob([pdfBytes]))
    createMetaDocument(formData)
    dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
  }

  if (mutationSuccess) {
    return (
      <Result
        status="success"
        title="Документ создан"
        subTitle={`Заявление на отпуск успешно сформировано.`}
        extra={[
          <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
            <Button type="primary">Создать еще</Button>
          </Link>
        ]}
      />
    )
  }

  return (
    <div className={style.generatorWrapper}>
      <h2 className={style.title}>Заявление на оплачиваемый отпуск</h2>
      
      <Form 
        form={form} 
        onFinish={onFinish} 
        layout="vertical"
        initialValues={{regtext: "Прошу Вас предоставить мне ежегодный оплачиваемый отпуск с "}}
      >
        <Item 
            label="Получатели" 
            name="recipients" 
            rules={[{ required: true, message: 'Выберите получателей' }]}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="Кому отправить заявление?"   
            size="large"
            filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
          >
            {recipientsList?.map((recipient) => (
                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                  {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                </Option>
            ))}
          </Select>
        </Item>

        <Item 
            label="Текст заявления" 
            name="regtext" 
            rules={[{ required: true, message: 'Заполните содержание' }]}
        >
          <Input placeholder="Напр: 01.06.2024 по 14.06.2024 на 14 календарных дней"/>
        </Item>

        <Button 
            type="primary" 
            htmlType="submit" 
            loading={mutationLoading}
            size="large"
            icon={<SendOutlined style={{ display: 'inline-flex', alignSelf: 'center' }} />}
            style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100%',
                marginTop: '20px'
            }}
        >
            Сформировать и отправить
        </Button>
      </Form>
    </div>
  )
}

export default Template;
